// extracted by mini-css-extract-plugin
export default {"form":"Form-module__form--Vk_8N","input":"Form-module__input--tbAv5","button":"Form-module__button--_RFYV"};